import dayjs from "dayjs";
import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {removeNullFields} from "../../../../common/mapper";
import {PaymentStatus} from "../../common/constants";
import Filter from "../common/filter";
import TabBBKBelumLengkap from "./tabBBKBelumLengkap";
import TabBBKBelumRealisasi from "./tabBBKBelumRealisasi";
import TabBBKRealisasi from "./tabBBKRealisasi";
import moment from "moment";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class TabBBK extends Component {
  constructor(props) {
    super(props);
    this.initialSearchData = {
      tanggalAwal: dayjs(new Date()).format("DD-MM-YYYY"),
      tanggalAkhir: dayjs(new Date()).format("DD-MM-YYYY"),
    };
    this.initialPagination = {
      totalData: 1,
      page: 1,
      limit: 5,
    };
    this.state = {
      tabIndex: 0,
      loading: false,
      submittedFilter: {},
      filterVisible: false,
      filterData: {},
      searchData: this.initialSearchData,
      skipNextPaginationFetch: false,
      dataTable: [],
      pagination: this.initialPagination,
    };
  }

  componentDidMount() {
    this.fetchData({
      tanggalBBK: this.initialSearchData,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tabIndex !== this.state.tabIndex) {
      this.refetch({
        tanggalBBK: this.initialSearchData,
      });
    }
    const { submittedFilterData, pagination, skipNextPaginationFetch } =
      this.state;
    if (prevProps.kodeCabang?.value !== this.props.kodeCabang?.value) {
      this.handleResetPeriode();
      this.handleResetPagination();

      this.fetchData(
        { ...submittedFilterData, tanggalBBK: this.initialSearchData },
        1,
        this.state.pagination.limit
      );
    }
    if (skipNextPaginationFetch) {
      this.setState({ skipNextPaginationFetch: false });
    }

    if (prevProps.kodeCabang?.value !== this.props.kodeCabang?.value) {
      this.handleResetPeriode();
      this.handleResetPagination();
      this.fetchData({
        ...submittedFilterData,
        tanggalBBK: this.initialSearchData,
      });
    }
  }

  fetchData = async (filter = {}, page = 1, limit = 5) => {
    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilterData: filter,
      loading:true
    }));
    
    const payload = {
      kodeCabang: this.props.kodeCabang?.value || "",
      paymentStatus: PaymentStatus.BELUM_LENGKAP,
      ...filter,
      operator: filter?.operator ? filter.operator.value : null,
      jenisRelasi: filter?.jenisRelasi ? filter.jenisRelasi.value : null,
      jenisDokumen: filter?.jenisDokumen ? filter.jenisDokumen.value : null,
      namaBank: filter?.namaBank ? filter.namaBank.value : null,
      tanggalBBK: filter?.tanggalBBK || {},
    }

    if(this.state.tabIndex === 2){
      payload.tanggalRealisasiPayment = filter?.tanggalBBK
      delete payload.tanggalBBK
    }

    const response = await Api.create("NAGAMAS_TRANSACTION").getBBKData({
      paramFilters: removeNullFields(payload),
      limit,
      page,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const total = response.data.data.reduce(
        (sum, item) => sum + (item.paymentAmount || 0),
        0
      );
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: response.data.data,
        loading:false,
        totalPayment: total,
        pagination: {
          ...prevValue.pagination,
          totalData: response.data.totalData,
        },
      }));
    } else {
      this.props.setError({
        menuName: "Transaksi Bank BBK",
        errorMessage: response.data.message,
      });
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: [],
        loading:false,
        pagination: {
          ...prevValue.pagination,
          totalData: 0,
        },
      }));
    }
  };

  handleTabChange = (index) => {
    this.setState((prevValue) => ({
      ...prevValue,
      tabIndex: index,
      filterData: {},
      searchData: this.initialSearchData,
    }));
    this.handleResetPagination();
  };

  handlePeriodChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: moment(value).format("DD-MM-YYYY"),
      },
    }));
  };

  handleSubmitPeriod = async () => {
    const paymentDate = removeNullFields(this.state.searchData);

    this.setState(
      (prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
      }),
      () => {
        this.refetch({ tanggalBBK: paymentDate });
      }
    );
  };

  handleSubmitFilter = async () => {
    const tanggalPayment = removeNullFields(
      this.getPeriodInput(this.state.filterData?.tanggalPayment)
    );
    const tanggalDocRef1 = removeNullFields(
      this.getPeriodInput(this.state.filterData?.tanggalDokumenRef1)
    );
    const tanggalDocRef2 = removeNullFields(
      this.getPeriodInput(this.state.filterData?.tanggalDokumenRef2)
    );
    const count = parseInt(this.state.filterData?.count, 10);

    const finalFilter = removeNullFields({
      ...this.state.filterData,
      tanggalPayment: tanggalPayment,
      tanggalDokumenRef1: tanggalDocRef1,
      tanggalDokumenRef2: tanggalDocRef2,
      bankId: this.state.filterData?.bankId?.value,
      ...(isNaN(count) ? {} : { count: count }),
    });
  
    this.setState(
      (prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
        },
      }),
      async () => {
        await this.refetch(finalFilter);
      }
    );

    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: false,
      searchData: {
        tanggalAwal: null,
        tanggalAkhir: null,
      },
    }));
  };


  handleClearFilter = () => {
    this.setState((prevValue) => ({ ...prevValue, filterData: {} }));
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleFilterDateChange = (key, name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [key]: {
          ...prevValue.filterData[key],
          [name]: value,
        },
      },
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  refetch = async (filter = {}) => {
    const { page, limit } = this.state.pagination;

    const paymentStatus =
      this.state.tabIndex === 0
        ? PaymentStatus.BELUM_LENGKAP
        : this.state.tabIndex === 1
        ? PaymentStatus.BELUM_REALISASI
        : PaymentStatus.REALISASI;

    const finalFilter = { ...filter, paymentStatus };

    await this.fetchData(finalFilter, page, limit);

    this.setState((prevValue) => ({
      ...prevValue,
      submittedFilter: finalFilter,
    }));
  };


  getPeriodInput = (data) => ({
    tanggalAwal: data?.tanggalAwal
      ? dayjs(data.tanggalAwal).format("DD-MM-YYYY")
      : null,
    tanggalAkhir: data?.tanggalAkhir
      ? dayjs(data.tanggalAkhir).format("DD-MM-YYYY")
      : null,
  });

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  handleResetPeriode = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      searchData: this.initialSearchData,
    }));
  };

  handleResetPagination = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: this.initialPagination,
      skipNextPaginationFetch: true,
    }));
  };

  handleRefresh = () => {
    const { page, limit } = this.state.pagination;
    const { submittedFilter } = this.state;
    
    this.fetchData(submittedFilter, page, limit);
  };

  render() {
    return (
      <div>
        <Tabs
          selectedIndex={this.state.tabIndex}
          onSelect={this.handleTabChange}
        >
          <TabList>
            <Tab>BELUM LENGKAP</Tab>
            <Tab>BELUM REALISASI</Tab>
            <Tab>REALISASI</Tab>
          </TabList>
          <TabPanel>
            <TabBBKBelumLengkap
              {...this.props}
              state={this.state}
              onRefresh={this.handleRefresh}
              submittedFilter={this.state.submittedFilter}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
          <TabPanel>
            <TabBBKBelumRealisasi
              {...this.props}
              state={this.state}
              onRefresh={this.handleRefresh}
              submittedFilter={this.state.submittedFilter}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
          <TabPanel>
            <TabBBKRealisasi
              {...this.props}
              state={this.state}
              onRefresh={this.handleRefresh}
              submittedFilter={this.state.submittedFilter}
              onPeriodChange={this.handlePeriodChange}
              onSubmitPeriod={this.handleSubmitPeriod}
              onShowFilter={this.handleFilterVisibility}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleRowsPerPage}
            />
          </TabPanel>
        </Tabs>
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.state.filterVisible && (
          <Filter
            {...this.props}
            tab="BBK"
            kodeCabang={this.props.kodeCabang?.value}
            data={this.state.filterData}
            visible={this.state.filterVisible}
            onClickClose={this.handleFilterVisibility}
            onValueChange={this.handleFilterValueChange}
            onDateChange={this.handleFilterDateChange}
            onSubmit={this.handleSubmitFilter}
            onClear={this.handleClearFilter}
          />
        )}
      </div>
    );
  }
}

export default TabBBK;
